import * as React from "react"
import { Container } from "@/components"
import * as styles from "./index.module.scss"

interface IProps {
  text: string
}

const PartnerIntroduce: React.FC<IProps> = ({ text }) => {
  return (
    <div className={styles.introduce}>
      <Container isSmall={true}>
        <p>{text}</p>
      </Container>
    </div>
  )
}

export default PartnerIntroduce
